import script from "./HTSnakeGameSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./HTSnakeGameSetting.vue?vue&type=script&setup=true&lang=js"

import "./HTSnakeGameSetting.vue?vue&type=style&index=0&id=f05584c4&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f05584c4"]])

export default __exports__